import script from "./PatientSchemeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientSchemeForm.vue?vue&type=script&setup=true&lang=js"

import "./PatientSchemeForm.vue?vue&type=style&index=0&id=485734d3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485734d3"]])

export default __exports__